<template>
    <div id="settings-virtual-checkin">
        <div class="card">
            <div class="ado-settings__title">
                <i class="fas fa-check-square"></i> Check-in Availability <i v-if="loadingDefault"
                    class="fas fa-spinner fa-spin fa-2x"></i>
            </div>
            <div class="card-body">
                <div v-if="alertAvailability.status" :class="getAlertClass(alertAvailability)" role="alert">
                    <i :class="getAlertIcon(alertAvailability)"></i> {{ alertAvailability.message }}
                </div>
                <form ref="checkinOptionsForm">
                    <general-checkin-settings-form ref="generalSystem" :settings="settings">
                    </general-checkin-settings-form>
                    <kiosk-checkin-settings-form ref="kioskSystem" :settings="settings">
                    </kiosk-checkin-settings-form>
                    <virtual-checkin-settings-form ref="virtualSystem" :settings="settings">
                    </virtual-checkin-settings-form>
                </form>
            </div>
            <div class="card-body text-right">
                <button v-if="!loadingAvailability" type="button" class="btn btn-success"
                    @click="setAvailabilitySettings()">Save</button>
                <button v-else type="button" class="btn btn-success" disabled><i class="fas fa-spinner fa-spin"></i>
                    Submitting</button>
            </div>
        </div>
        <div class="card mt-3">
            <div class="ado-settings__title">
                <i class="fas fa-clock"></i> Check-in Hours of Operation <i v-if="loadingDefault"
                    class="fas fa-spinner fa-spin fa-2x"></i>
            </div>
            <div class="card-body">
                <div v-if="alertHoursOfOperation.status" :class="getAlertClass(alertHoursOfOperation)" role="alert">
                    <i :class="getAlertIcon(alertHoursOfOperation)"></i> {{ alertHoursOfOperation.message }}
                </div>
                <hours-of-operation-checkin-settings-form ref="hoursOfOperationSystem" :settings="settings"
                    @setHoursOfOperationValidation="setHoursOfOperationValidation">
                </hours-of-operation-checkin-settings-form>
            </div>
            <div class="card-body text-right">
                <button v-if="!loadingHoursOfOperation" type="button" class="btn btn-success"
                    :disabled="getValidHoursOfOperationForm()" @click="setHoursOfOperationSettings()">Save</button>
                <button v-else type="button" class="btn btn-success" disabled><i class="fas fa-spinner fa-spin"></i>
                    Submitting</button>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralCheckinSettingsForm from '../../../components/Settings/CheckinOptions/GeneralForm';
import HoursOfOperationCheckinSettingsForm from '../../../components/Settings/CheckinOptions/HoursOfOperation.vue';
import KioskCheckinSettingsForm from '../../../components/Settings/CheckinOptions/KioskForm.vue';
import VirtualCheckinSettingsForm from '../../../components/Settings/CheckinOptions/VirtualForm.vue';

export default {
    name: 'settings-checkin-options',
    components: {
        GeneralCheckinSettingsForm,
        KioskCheckinSettingsForm,
        HoursOfOperationCheckinSettingsForm,
        VirtualCheckinSettingsForm
    },
    data() {
        return {
            alertAvailability: {
                message: '',
                status: false,
                type: ''
            },
            alertHoursOfOperation: {
                message: '',
                status: false,
                type: ''
            },
            loadingAvailability: false,
            loadingHoursOfOperation: false,
            loadingDefault: true,
            refreshCycle: '',
            settings: {}
        }
    },
    methods: {
        getAlertClass(alert) {
            if (alert.type == "success") {
                return `alert alert-success`;
            } else if (alert.type == "warning") {
                return `alert alert-warning`;
            } else if (alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon(alert) {
            if (alert.type == "success") {
                return `fas fa-check`;
            } else if (alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        getValidHoursOfOperationForm() {
            if (this.$refs.hoursOfOperationSystem) {
                return this.$refs.hoursOfOperationSystem.validateForm();
            }

            return false;
        },
        getSettings() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?systemGet`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Retrieved system settings
                    if (json.result.match(/OK/i)) {
                        // Store system data
                        that.alertAvailability.status = false;
                        that.settings = json.data ? json.data : that.settings;

                        // Set system settings
                        setTimeout(function () {
                            if (that.$refs.generalSystem) {
                                that.$refs.generalSystem.setSettings();
                            }

                            if (that.$refs.hoursOfOperationSystem) {
                                that.$refs.hoursOfOperationSystem.setSettings();
                            }

                            if (that.$refs.kioskSystem) {
                                that.$refs.kioskSystem.setSettings();
                            }

                            if (that.$refs.virtualSystem) {
                                that.$refs.virtualSystem.setSettings();
                            }
                        }, 500);
                    } else if (json.result.match(/WARNING/i)) {
                        // Other error
                        that.alertAvailability.message = `Availability settings could not be retrieved. ${json.message}`;
                        that.alertAvailability.status = true;
                        that.alertAvailability.type = "warning";
                    } else {
                        // Internal error
                        that.alertAvailability.message = `Availability settings could not be retrieved. An error has occurred. Please contact your system administrator.`;
                        that.alertAvailability.status = true;
                        that.alertAvailability.type = "danger";
                    }

                    that.loadingDefault = false;
                })
                .catch(function () {
                    // Internal error
                    that.alertAvailability.message = `Availability settings could not be retrieved. An error has occurred. Please contact your system administrator.`;
                    that.alertAvailability.status = true;
                    that.alertAvailability.type = "danger";
                    that.loadingDefault = false;
                })
        },
        refreshData() {
            // Update data
            this.getSettings();
        },
        setAvailabilitySettings() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?systemSet`;
            const formData = new FormData();
            let generalSettings = this.$refs.generalSystem.getSettings();
            let kioskSettings = this.$refs.kioskSystem.getSettings();
            let virtualSettings = this.$refs.virtualSystem.getSettings();

            this.alertAvailability.message = ``;
            this.alertAvailability.status = false;
            this.alertAvailability.type = "";
            this.loadingAvailability = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                types: [
                    generalSettings,
                    kioskSettings,
                    virtualSettings
                ]
            }));
            formData.append('mode', 'systemSet');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alertAvailability.message = `Availability settings has been successfully updated!`;
                    that.alertAvailability.status = true;
                    that.alertAvailability.type = "success";

                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alertAvailability.message = `Availability settings could not be updated. ${json.message}`;
                    that.alertAvailability.status = true;
                    that.alertAvailability.type = "warning";
                } else {
                    // Internal error
                    that.alertAvailability.message = `Availability settings could not be updated. An error has occurred. Please contact your system administrator.`;
                    that.alertAvailability.status = true;
                    that.alertAvailability.type = "danger";
                }

                that.refreshData();
                that.loadingAvailability = false;
            }).catch(function () {
                // Internal error
                that.refreshData();
                that.alertAvailability.message = `Availability settings could not be updated. An error has occurred. Please contact your system administrator.`;
                that.alertAvailability.status = true;
                that.alertAvailability.type = "danger";
                that.loadingAvailability = false;
            })
        },
        setHoursOfOperationSettings() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?systemSet`;
            const formData = new FormData();
            let hoursOfOperationSettings = this.$refs.hoursOfOperationSystem.getSettings();

            this.alertHoursOfOperation.message = ``;
            this.alertHoursOfOperation.status = false;
            this.alertHoursOfOperation.type = "";
            this.loadingHoursOfOperation = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                types: [
                    hoursOfOperationSettings
                ]
            }));
            formData.append('mode', 'systemSet');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alertHoursOfOperation.message = `Hours of operation settings has been successfully updated!`;
                    that.alertHoursOfOperation.status = true;
                    that.alertHoursOfOperation.type = "success";

                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alertHoursOfOperation.message = `Hours of operation settings could not be updated. ${json.message}`;
                    that.alertHoursOfOperation.status = true;
                    that.alertHoursOfOperation.type = "warning";
                } else {
                    // Internal error
                    that.alertHoursOfOperation.message = `Hours of operation settings could not be updated. An error has occurred. Please contact your system administrator.`;
                    that.alertHoursOfOperation.status = true;
                    that.alertHoursOfOperation.type = "danger";
                }

                that.refreshData();
                that.loadingHoursOfOperation = false;
            }).catch(function () {
                // Internal error
                that.refreshData();
                that.alertHoursOfOperation.message = `Hours of operation settings could not be updated. An error has occurred. Please contact your system administrator.`;
                that.alertHoursOfOperation.status = true;
                that.alertHoursOfOperation.type = "danger";
                that.loadingHoursOfOperation = false;
            })
        }
    },
    created() {
        const that = this;

        // Retrieve database
        this.refreshData();

        // Auto refresh
        // this.refreshCycle = setInterval(function () {
        //     that.refreshData();
        // }, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    }
}
</script>